//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { map , filter } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const examsInitial = [];




export const apexams = (state = examsInitial, action) => {
    switch (action.type) {
        case ActionTypes.apexams.createApExamsSuccess:
            return [action.payload, ...state];
        case ActionTypes.apexams.listApExamsSuccess:
            return action.payload;
        case ActionTypes.apexams.updateApExamsSuccess:
            return map(state,dt=>{
                if(dt.id===action.payload.id){
                    return action.payload;
                }
                return dt;
            })
        case ActionTypes.apexams.deleteApExamsSuccess:
            return filter(state,dt=>dt.id!==action.payload)
        default:
            return state;
    }
};
